import styled from "styled-components";

export const AspectRatio = styled.div`
  position: relative;
  padding-top: ${(9 / 16) * 100}%;

  > div {
    position: absolute;
    top: 0;
    left: 0;
  }
`;
